import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCardGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M17.222 4.5H6.778c-.821 0-1.468 0-1.99.043-.53.043-.974.133-1.377.338a3.5 3.5 0 0 0-1.53 1.53c-.205.403-.295.847-.338 1.378-.043.52-.043 1.168-.043 1.989v4.444c0 .822 0 1.469.043 1.99.043.53.133.974.338 1.377a3.5 3.5 0 0 0 1.53 1.53c.403.205.847.295 1.378.338.52.043 1.168.043 1.989.043h10.444c.822 0 1.468 0 1.99-.043.53-.043.974-.133 1.377-.338a3.5 3.5 0 0 0 1.53-1.53c.205-.403.295-.847.338-1.378.043-.52.043-1.167.043-1.989V9.778c0-.821 0-1.468-.043-1.99-.043-.53-.133-.974-.338-1.377a3.5 3.5 0 0 0-1.53-1.53c-.403-.205-.847-.295-1.378-.338-.52-.043-1.167-.043-1.989-.043'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M17.241 4H6.76c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C1 8.29 1 8.954 1 9.758v4.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 20 5.954 20 6.758 20h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V9.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C18.71 4 18.046 4 17.242 4M4.092 6.218c.156-.08.38-.145.819-.18C5.361 6 5.943 6 6.8 6h10.4c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819L20.97 8H3.031l.007-.089c.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874M3 10v4.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C5.361 18 5.943 18 6.8 18h10.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V10z'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      d='M4 15c0-.67.33-1 1-1h2c.67 0 1 .33 1 1s-.33 1-1 1H5c-.67 0-1-.33-1-1M11 15q0 1-1 1t-1-1 1-1 1 1'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCardGhost)
export default ForwardRef
